
export default function FilterToggle({openFilterToggle, showFilterToggle, filters, setActiveFilter, activeFilter}) {

    if (!openFilterToggle) {
        return null
    }
    return (
        <div className=" w-full fixed pt-[130px]  h-[40px] px-4 z-20 ">

            <div
                className={`overflow-hidden transition-all duration-300 ease-out ${
                    showFilterToggle ? "max-h-[200px] opacity-100 " : "max-h-0 opacity-0"
                }`}
            >
                <div className="flex flex-wrap gap-2 p-4 bg-white rounded-xl border border-border shadow-sm">
                    {filters.map((filter) => (
                        <button
                            key={filter}
                            onClick={() => setActiveFilter(filter)}
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                                activeFilter === filter
                                    ? "bg-primary text-white"
                                    : "bg-gray-100 text-text-secondary hover:bg-gray-200"
                            }`}
                        >
                            {filter.charAt(0).toUpperCase() + filter.slice(1)}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    )
}
